"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WastewaterUnitMeasure = exports.WastewaterUnits = void 0;
var WastewaterUnits; // type of unit config that declared in industrial-stormwater-sector-data repo

/* eslint-disable camelcase */

exports.WastewaterUnits = WastewaterUnits;

(function (WastewaterUnits) {
  WastewaterUnits["CELSIUS"] = "celsius";
  WastewaterUnits["CENTIMETERS"] = "centimeters";
  WastewaterUnits["CFU_PER_100ML"] = "cfu_per_100ml";
  WastewaterUnits["CNT_PER_100ML"] = "cnt_per_100ml";
  WastewaterUnits["COLIFORMS_PER_100ML"] = "coliforms_per_100ml";
  WastewaterUnits["FAHRENHEIT"] = "fahrenheit";
  WastewaterUnits["FEET"] = "feet";
  WastewaterUnits["FLUIDOUNCE"] = "fluidounce";
  WastewaterUnits["GALLONS"] = "gallons";
  WastewaterUnits["GALLONS_PER_MINUTE"] = "gallons_per_minute";
  WastewaterUnits["GRAM"] = "gram";
  WastewaterUnits["INCHES"] = "inches";
  WastewaterUnits["LITRE"] = "litre";
  WastewaterUnits["METERS"] = "meters";
  WastewaterUnits["MICROGRAMS_PER_LITER"] = "micrograms_per_liter";
  WastewaterUnits["MICROMHOS_PER_CENTIMETER"] = "micromhos_per_centimeter";
  WastewaterUnits["MICROSIEMENS_PER_CENTIMETER"] = "microsiemens_per_centimeter";
  WastewaterUnits["MILLIGRAMS_PER_LITER"] = "milligrams_per_liter";
  WastewaterUnits["MILLILITERS_PER_LITER"] = "milliliters_per_liter";
  WastewaterUnits["MILLILITERS_PER_LITER_PER_HOUR"] = "milliliters_per_liter_per_hour";
  WastewaterUnits["MILLILITER"] = "milliliter";
  WastewaterUnits["MILLIMHOS_PER_CENTIMETER"] = "millimhos_per_centimeter";
  WastewaterUnits["MILLIONS_GALLONS_PER_MINUTE"] = "millions_gallons_per_minute";
  WastewaterUnits["MILLIONS_OF_GALLONS"] = "millions_of_gallons";
  WastewaterUnits["MILLION_FIBERS_PER_LITER"] = "million_fibers_per_liter";
  WastewaterUnits["MINUTES"] = "minutes";
  WastewaterUnits["MPN_PER_100_ML"] = "mpn_per_100_mL";
  WastewaterUnits["NANOGRAMS_PER_LILITER"] = "nanograms_per_liter";
  WastewaterUnits["NANOGRAMS_PER_MILLILITER"] = "nanograms_per_milliliter";
  WastewaterUnits["NTU"] = "ntu";
  WastewaterUnits["OUNCE"] = "ounce";
  WastewaterUnits["PARTS_PER_MILLION"] = "parts_per_million";
  WastewaterUnits["PASS_FAIL"] = "pass_fail";
  WastewaterUnits["PERCENT"] = "percent";
  WastewaterUnits["PERCENT_GRAMS_PER_LITER"] = "percent_grams_per_liter";
  WastewaterUnits["PERCENT_SURVIVAL"] = "percent_survival";
  WastewaterUnits["PERCENT_VOLUME_PER_VOLUME"] = "percent_volume_per_volume";
  WastewaterUnits["PICOGRAMS_PER_MILLILITER"] = "picograms_per_milliliter";
  WastewaterUnits["PICOCURIES_PER_LITER"] = "pCi_per_liter";
  WastewaterUnits["POUNDS"] = "pounds";
  WastewaterUnits["POUNDS_PER_DAY"] = "pounds_per_day";
  WastewaterUnits["PPT"] = "ppt";
  WastewaterUnits["SU"] = "standard_units";
  WastewaterUnits["TONS"] = "tons";
  WastewaterUnits["TOXIC_UNIT_ACUTE"] = "toxic_unit_acute";
  WastewaterUnits["YES_NO"] = "yes_no";
})(WastewaterUnits || (exports.WastewaterUnits = WastewaterUnits = {}));

var WastewaterUnitMeasure;
exports.WastewaterUnitMeasure = WastewaterUnitMeasure;

(function (WastewaterUnitMeasure) {
  WastewaterUnitMeasure["BACTERIA_COUNT"] = "bacteria_count";
  WastewaterUnitMeasure["CONCENTRATION"] = "concentration";
  WastewaterUnitMeasure["LENGTH"] = "length";
  WastewaterUnitMeasure["PERCENT"] = "percent";
  WastewaterUnitMeasure["SOIL_ELECTRICAL_CONDUCTIVITY"] = "soil_electrical_conductivity";
  WastewaterUnitMeasure["TEMPERATURE"] = "temperature";
})(WastewaterUnitMeasure || (exports.WastewaterUnitMeasure = WastewaterUnitMeasure = {}));
/* eslint-enable camelcase */